import { PaymentMethod } from '@api/GoodocAPI';
import constate from 'constate';
import { useState } from 'react';
import { UntactDepartmentObject } from './types';

/*
  TODO:
  환자 정보 입력에 관련된 컴포넌트에만 갖혀있어야함
  react router dom의 특성상 격리가 불가능
  때문에 Stack 기반으로 라우팅할까 고민했지만 선택하지않았음
  추후 격리시키는 방법을 고민해야할것같다
*/
const useTreatmentInformation = () => {
  const [selectedUntactDepartment, setSelectedUntactDepartment] =
    useState<UntactDepartmentObject>();
  const [selectedDoctorId, setSelectedDoctorId] = useState('');
  // FIXME: patientName으로 ...
  const [name, setName] = useState<string>('');
  const [registrationNumber, setRegistrationNumber] = useState<string>('');
  const [isNew, setIsNew] = useState<boolean>(false); // FIXME: remove this
  const [selectedPatientId, setSelectedPatientId] = useState<string>('');
  const [selectedCreditCard, setSelectedCreditCard] = useState<Partial<PaymentMethod>>();

  const resetPatientInformation = () => {
    setName('');
    setRegistrationNumber('');
  };

  return {
    name,
    setName,
    registrationNumber,
    setRegistrationNumber,
    isNew,
    setIsNew,
    selectedPatientId,
    setSelectedPatientId,
    resetPatientInformation,
    selectedUntactDepartment,
    setSelectedUntactDepartment,
    selectedDoctorId,
    setSelectedDoctorId,
    selectedCreditCard,
    setSelectedCreditCard
  };
};

export const [TreatmentInformationProvider, useTreatmentInformationContext] = constate(
  useTreatmentInformation
);
